import "bootstrap"
import "./index.scss"
import { createApp } from "vue"
import router from "./router"
import App from "./components/App.vue"
import Vue3EasyDataTable from 'vue3-easy-data-table'

import Datepicker from '@vuepic/vue-datepicker'
import ErrorDialog from './components/ErrorDialog.vue'
import ConfirmDialog from './components/ConfirmDialog.vue'
import LoadingDialog from './components/LoadingDialog.vue'
import '@vuepic/vue-datepicker/dist/main.css'
import 'vue3-easy-data-table/dist/style.css'

const app = createApp(App);
app.component('Datepicker', Datepicker);
app.component('EasyDataTable', Vue3EasyDataTable);
app.component('ErrorDialog', ErrorDialog);
app.component('ConfirmDialog', ConfirmDialog);
app.component('LoadingDialog', LoadingDialog);
app.use(router);
app.mount('#app');
